require('../modules/web.dom.iterable');
require('../modules/es6.string.iterator');
module.exports = require('../modules/core.get-iterator');


/*****************
 ** WEBPACK FOOTER
 ** /home/rengasturku/nettivanne/~/babel-runtime/~/core-js/library/fn/get-iterator.js
 ** module id = 371
 ** module chunks = 1 2 3 10 11 12 13 14 15 16 17 19 20 21 22 26 33 34
 **/